<template>
<v-container fluid grid-list-xl class="pa-0">
  <v-layout row wrap>
    <v-flex xs12 sm6 md3>
    <box-chart 
      :card-color="chartColor.card"
      title="Customers"
      sub-title="10%"
      icon="trending_up"
      :data="monthly"
      :lastItem="[monthly[monthly.length-1]['Customers']]"
      :chart-color="chartColor.chart"
      type="area"
    />
    </v-flex>
    <v-flex xs12 sm6 md3>
    <box-chart 
      :card-color="chartColor.card"
      title="Orders"
      sub-title="10%"
      icon="trending_up"
      :data="monthly"
      :lastItem="[monthly[monthly.length-1]['Customers']]"
      :chart-color="chartColor.chart"
      type="area"
    />
    </v-flex>
    <v-flex xs12 sm6 md3>
    <box-chart 
      :card-color="chartColor.card"
      title="Subscriptions"
      sub-title="10%"
      icon="trending_up"
      :data="monthly"
      :lastItem="[monthly[monthly.length-1]['Customers']]"
      :chart-color="chartColor.chart"
      type="area"
    />
    </v-flex>
    <v-flex xs12 sm6 md3>
    <box-chart 
      :card-color="chartColor.card"
      title="Billed"
      sub-title="10%"
      icon="trending_up"
      :data="monthly"
      :lastItem="[monthly[monthly.length-1]['Customers']]"
      :chart-color="chartColor.chart"
      type="area"
    />
    </v-flex>
    <v-flex xs12 sm3>
      <metric
      :card-color="chartColor.metric"
      :metric="stats.subscriptions"
      subtitle="Subscriptions"
      />
    </v-flex>
    <v-flex xs12 sm3>
      <metric
      :card-color="chartColor.metric"
      :metric="stats.drafts"
      subtitle="Drafts"
      />
    </v-flex>
    <v-flex xs12 sm3>
      <metric
      :card-color="chartColor.metric"
      :metric="stats.outgoing_shipments"
      subtitle="Outgoing Shipments"
      />
    </v-flex>
    <v-flex xs12 sm3>
      <metric
      :card-color="chartColor.metric"
      :metric="stats.incoming_shipments"
      subtitle="Incoming Shipments"
      />
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { db } from '@/services/firebase.js'

export default {
  name: 'Dashboard',
  components: {
    BoxChart: () => import('@/components/chart/BoxChart'),
    Metric: () => import('@/components/chart/Metric')
  },
  data () {
    return {
      stats: {
        subscriptions: 0,
        drafts: 0,
        outgoing_shipments: 0,
        incoming_shipments: 0
      }
    }
  },
  computed: {
    monthly: function () {
      const shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
      const monthVisitData = shortMonth.map((m) => {
        return {
          'month': m,
          'Customers': Math.floor(Math.random() * 1000) + 200,
          'Page View': Math.floor(Math.random() * 1000) + 250,
        }
      })
      return monthVisitData
    },
    chartColor: function () {
      if(this.$vuetify.dark){
        return {card: '#212121', chart: ['#424242'], metric: '#212121'}
      } else {
        return {card: '#FFFFFF', chart: ['#1976d2'], metric: '#1976d2'}
      }
    }
  },
  created () {
    var self = this
    db.collection('settings').doc('counts').onSnapshot(countSnapshot => {
      self.stats = countSnapshot.data()
    })
  },
  mounted () {
   
  }
}
</script>